import { useEffect, useRef } from 'react';
import { Box } from '@zillow/constellation-10';
import { useEsusu } from '../../contexts/EsusuContext';
import type { EsusuSDK, InitOptions } from '../../types/esusuSdk';

export default function EsusuWrapper({ config }: { config: InitOptions }) {
  const {
    esusuSdk,
    setShouldInitializeEsusu,
    isEsusuScriptLoaded,
    markContainerAsInitialized,
    isContainerInitialized,
    removeContainerFromInitialized,
  } = useEsusu();
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (isEsusuScriptLoaded && !esusuSdk && !hasInitialized.current) {
      hasInitialized.current = true;
      setShouldInitializeEsusu(true);
    }
  }, [isEsusuScriptLoaded, esusuSdk, setShouldInitializeEsusu]);

  useEffect(() => {
    const containerId = config.containerId;

    if (esusuSdk && !isContainerInitialized(containerId)) {
      markContainerAsInitialized(containerId);
      (esusuSdk as EsusuSDK).init(config);
    }

    // Cleanup on unmount: destroy the instance and remove from initialized set
    return () => {
      if (esusuSdk && isContainerInitialized(containerId)) {
        (esusuSdk as EsusuSDK).destroyInstance(containerId);
        removeContainerFromInitialized(containerId);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [esusuSdk, isContainerInitialized, markContainerAsInitialized, removeContainerFromInitialized]);

  const esusuCompletelyLoaded = isEsusuScriptLoaded && esusuSdk;

  return (
    <Box css={{ display: esusuCompletelyLoaded ? 'block' : 'none', height: '100%' }}>
      <div id={config.containerId} style={{ height: '100%' }}></div>
    </Box>
  );
}
